import { render } from "./person-info.vue?vue&type=template&id=c502975e&scoped=true"
import script from "./person-info.vue?vue&type=script&lang=js"
export * from "./person-info.vue?vue&type=script&lang=js"

import "./person-info.vue?vue&type=style&index=0&id=c502975e&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c502975e"]])

export default __exports__